var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-info-banner-wrapper"},[_c('div',{staticClass:"order-info-banner"},[_c('ul',[_c('li',[_c('span',[_vm._v("Bénéficiaire :")]),_vm._v(" "),_c('span',[_vm._v("Testachats")])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("Prix total :")]),_vm._v(" "),_c('span',[_vm._v("2,00 €")])])])])])
}]

export { render, staticRenderFns }